import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedContent from './components/FeaturedContent';
import CategorySection from './components/CategorySection';
import LatestVideos from './components/LatestVideos';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '小宝探花',
    url: 'https://npjyf.cn',
    description: '小宝探花官方页面，汇聚小宝探花最新精彩内容、独家视频与达人动态。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://npjyf.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '小宝探花',
    url: 'https://npjyf.cn',
    description: '探花达人带你玩转精彩内容',
    sameAs: [],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedContent />
          <CategorySection />
          <LatestVideos />

          <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20atmospheric%20abstract%20background%20with%20soft%20golden%20and%20amber%20gradients%2C%20subtle%20texture%2C%20elegant%20minimal%2C%20cinematic%20lighting%2C%20warm%20cozy%20vibe&width=1920&height=600&seq=cta-home-bg-01&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
            <div className="relative z-10 max-w-2xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
                加入小宝探花，开启精彩之旅
              </h2>
              <p className="text-sm md:text-base text-background-50/80 mb-8">
                关注小宝探花，第一时间获取最新视频、独家内容和福利活动。和小宝一起探索世界的每一个精彩角落！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/latest"
                  className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-all active:scale-95"
                >
                  观看最新视频
                </Link>
                <Link
                  to="/about"
                  className="whitespace-nowrap px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium hover:bg-background-50/10 transition-all"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          <FAQSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}